import LinkDefault from './Link';
import LinkGlobal from './LinkGlobal';

const Link =
  process.env.GATSBY_LANG === 'ae' || process.env.GATSBY_LANG === 'az' ? LinkGlobal : LinkDefault;

export default Link;
